// extracted by mini-css-extract-plugin
module.exports = {"container":"ForgotPasswordLink_container__1ov3L","link":"ForgotPasswordLink_link__2hdqd","right":"ForgotPasswordLink_right__2-yXg"};